import Vue from "vue";

import Terms from "./TermsAndConditions.vue";

export function load() {
    const selector = "terms-and-conditions";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(Terms, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
